import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import './ResourceTest.css';

import Button from '../../App/Common/Button/Button';

const ResourceTestBeginning = ({ data }) => {
    // console.log(data)
    return (

        <div className='resourseTest__container'>
        <div className='resourseTest__table'>
            <div className='resourseTest__field'>
            Тест:
                <div className='resourseTest__data'>{data.title}</div>
            </div>
            <div className='resourseTest__field'>
            Количество попыток:
                <div className='resourseTest__data'>{data.attempts_number > 0 ? data.attempts_number : 'Не ограничено'}</div>
            </div>
            <div className='resourseTest__field'>
            Количество вопросов:
                <div className='resourseTest__data'>{data.num_of_questions}</div>
            </div>
           
        </div>
        <div className='resourseTest__buttons'>
            <Link to={`/test/${data.id}`}><Button buttonText={'Приступить к выполнению'} color={'#7A5AF8'} type={'filled'} /></Link> 
        </div>
    </div>
    )
}
export default ResourceTestBeginning
